import request from '#/utils/request';
import { parseLoginResponse } from '#/api/adapters/envelope';

/**
 * 登入 API — Ver4 envelope。
 * @see docs/API_AUTH.md
 */
export async function login(credentials) {
  const { data: raw } = await request.post('/auth/login', credentials, {
    skipAuth: true,
  });
  return parseLoginResponse(raw);
}
